// 通用工具
export default {
  cloneObject: function (source, props) {
    let obj = {}
    props.forEach(k => { obj[k] = source[k] })
    return obj
  },
  returnSuccess: function (resp) {
    return resp && resp.code === 200 && resp.bizCode === 200
  }
}
